<template>
  <pl-dialog
    size="sm"
    title="Delete Suggestion"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <div class="flex justify-center">
      <div class="flex justify-center mt-10 mb-4">
        <i class="fa-solid fa-circle-exclamation text-4xl text-red-500"></i>
      </div>
    </div>
    <p class="text-center px-20 text-gray-800 mb-8">
      Are you sure you want to delete this
      <span class="font-semibold">' {{ suggestion.text }} '</span> ? This
      <span class="font-semibold">action is irreversible</span> and has
      consequences <span class="font-semibold">only in this course.</span>
    </p>
    <input
      placeholder="Please type 'confirm' to continue"
      class="bg-gray-100 rounded py-3 px-4 outline-none mx-12 mb-2"
      v-model="confirmMessage"
      ref="confirmDeleteSuggestion"
    />
    <span
      :class="errorMessage !== 'No Error' ? 'text-red-500' : 'text-white'"
      class="mx-12 mb-16"
    >
      {{ errorMessage }}
    </span>
    <div class="flex justify-center bottom-10">
      <button
        @click="$emit('openMySuggestionsModal')"
        class="bg-gray-100 rounded px-5 py-2 mr-3"
      >
        Cancel
      </button>
      <button
        @click="deleteSuggestion()"
        class="px-5 py-2 bg-red-500 rounded text-white"
      >
        Delete Suggestion
      </button>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from '../../../../utils/event-bus';
  export default Vue.extend({
    data() {
      return {
        confirmMessage: '',
        errorMessage: 'No Error',
      };
    },
    watch: {
      confirmMessage: function (old, newValue) {
        if (old !== newValue) this.errorMessage = 'No Error';
      },
    },
    computed: {
      ...mapGetters(['getCourseDetail']),
    },
    props: {
      suggestion: { type: Object, default: {} },
    },
    methods: {
      deleteSuggestion: function () {
        if (this.confirmMessage !== 'confirm')
          return (this.errorMessage = 'Incorrect spelling. Please try again');
        const suggestion = {
          course_id: this.getCourseDetail.id,
          feedback_id: this.suggestion.id,
          onlineRT: false,
        };
        this.$store.dispatch('deleteFeedback', suggestion).then(() => {
          this.confirmMessage = '';
          const toast = {
            type: 'Success',
            message: 'Suggestion successfully deleted!',
            time: 5000,
          };
          this.$emit('close');
          EventBus.$emit('createToast', toast);
        });
      },
    },
  });
</script>



// WEBPACK FOOTER //
// DeleteSuggestionSaved.vue?2c87ebf2